import { AuthState } from "@/components/auth/types";
import { Module } from "vuex";
import { RootState } from "@/store/RootState";
import { mutations } from "@/components/auth/store/mutations";
import { getters } from "@/components/auth/store/getters";
import { actions } from "@/components/auth/store/actions";

export const state: AuthState = {};

export const auth: Module<AuthState, RootState> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
